import LegalLayout from "./Legallayout";
import { COOKIE_POLICY } from "./Legaldata";

export default function CookiePolicy() {
  return <LegalLayout doc={COOKIE_POLICY} />;
}